export default __webpack_public_path__ + "static/media/radiant-bright-yellow-orange.5ea78cd3.jpg";